import React from 'react'
// import PropTypes from 'prop-types'

// @material-ui/core components
// import withStyles from '@material-ui/core/styles/withStyles'
// @material-ui/icons

// core components
import AutoCompleteDropdown from 'components/CustomDropdown/AutoCompleteDropdown'


// Apollo thingy
import { graphql, Query } from 'react-apollo'

//wrapper specific, each dropdown needs a specific one
import { dictUserGroups } from '../../queries/getDataForDropdowns'

// props here holds the classes and pass it down
class DropdownUserGroups extends React.Component {
  render() {
    return (
      <Query query={dictUserGroups} errorPolicy="all">
        {({ loading, error, data }) => {
          // console.log(data)
          if (error) return <p>Database connection error</p>
          if (loading) {
            return <p>Loading...</p>
          } else {
            const { helperText = 'Choose group', labelText = '', ...rest } = this.props
            return (
              <AutoCompleteDropdown
                options={data.userGroups.map(g => ({ value: g.id, label: g.name }))}
                placeholder={helperText}
                labelText={labelText}
                {...rest}
              />
            )
          }
        }}
      </Query>
    )
  }
}

DropdownUserGroups.propTypes = {
  // classes: PropTypes.object.isRequired
}

export default graphql(dictUserGroups)(DropdownUserGroups)
